import React from "react";
import PropTypes from "prop-types";
import { ORDER_STATUS_FILTERS } from "../constants/order-status-filters";

// Order status chips (src/v2/constants/order-status-filters.js). Multi-select toggles,
// styled exactly like the ops Orders tab's chips so the filter looks the same in every
// console. No selection means "every status".
//
// `options` lets a page show only the chips that make sense for it -- pharmacy hides the
// ones that cannot match anything in its active sub-tab.
function OrderStatusFilter({ selected, onChange, options }) {
    const toggle = (id) =>
        onChange(selected.includes(id) ? selected.filter((entry) => entry !== id) : [...selected, id]);

    return (
        <div className="flex flex-wrap items-center gap-2">
            {options.map((option) => (
                <button
                    key={option.id}
                    type="button"
                    aria-pressed={selected.includes(option.id)}
                    onClick={() => toggle(option.id)}
                    className={`rounded-[10px] px-2 py-1 text-[10px] ${
                        selected.includes(option.id) ? "bg-elm-500 text-white-50" : "bg-gray-200 text-[#333]"
                    }`}
                >
                    {option.label}
                </button>
            ))}
            {selected.length > 0 && (
                <button
                    type="button"
                    onClick={() => onChange([])}
                    className="px-1 text-[10px] font-semibold text-elm-500 underline"
                >
                    Clear
                </button>
            )}
        </div>
    );
}

OrderStatusFilter.propTypes = {
    selected: PropTypes.arrayOf(PropTypes.string).isRequired,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({ id: PropTypes.string.isRequired, label: PropTypes.string.isRequired })
    ),
};

OrderStatusFilter.defaultProps = {
    options: ORDER_STATUS_FILTERS,
};

export default OrderStatusFilter;
